// import partInfo from "./partInfo";
import partInfo from "./partInfoMY22";

export * from "./ModelManager";

export class ModelManagerOld {
  constructor(bikeGeometryManager) {
    this._bikeGeometryManager = bikeGeometryManager;
    this._sketchfabAPIUtility = null;
    // add the model manager to the window so we can access it in console debugging
    window._modelManager = this;
  }

  initialize(sketchfabAPIUtility) {
    this._sketchfabAPIUtility = sketchfabAPIUtility;
  }

  showModel(model) {
    this._bikeGeometryManager.reset();
    let bikeType;
    // eslint-disable-next-line default-case
    switch (model) {
      case "STD":
        bikeType = "base";
        // this lets the bikeGeometryManager know that the stock handlebar, accessories, and handle are visible
        this._bikeGeometryManager.addNodes(["MY22_600_900_sport","600_900_sport_stock_handlebar"]);
        break;
      case "SPORT":
        bikeType = "sport";
        // this lets the bikeGeometryManager know that the stock handlebar, accessories, and handle are visible
        this._bikeGeometryManager.addNodes([
          "MY22_600_900_sport",
          "600_900_sport_stock_handlebar",
          "accessory_219401135_cruise_control_sport_rally_POSITION_IF_stock_handle",
          "accessory_cruise_control_attache_sport_POSITION_IF_stock_handle",
          "accessory_219401169_1_1_Structure_rally_sport",
        ]);
        this._bikeGeometryManager.addParts(["219401135", "219401169"]);
        break;
      case "AR":
        bikeType = "rally";
        // this lets the bikeGeometryManager know that the stock handlebar, accessories, and handle are visible
        this._bikeGeometryManager.addNodes([
          "MY22_rally",
          "rally_stock_handlebar",
          "accessory_219401135_cruise_control_sport_rally_POSITION_IF_stock_handle",
          "accessory_219400998_Full_Wrap_Handguard_POSITION_IF_stock_handlebar_rally",
          "accessory_219400963_fender_rear rally",
          "accessory_219401028_full_body_skid_plate_rally",
          "accessory_219401108_front_bumper_rally",
          "accessory_219401137_mud_flap_rally",
          "accessory_219401169_1_1_Structure_rally_sport",
        ]);
        this._bikeGeometryManager.addParts([
          "219401135",
          "219400998",
          "219400963",
          "219401028",
          "219401108",
          "219401137",
          "219401169",
        ]);

        break;
    }
    // this lets the bikeGeometryManager know that the stock handlebar, accessories, and handle are visible
    this._bikeGeometryManager.addNodes(["common_stock_handlebar_kit"]);
    this._bikeGeometryManager.addNodes(["common_stock_handle"]);

    for (const index in partInfo.common) {
      this._sketchfabAPIUtility.setNodeVisibility(partInfo.common[index], 1);
    }
    const bikeParts = partInfo[bikeType];
    for (const index in bikeParts) {
      this._sketchfabAPIUtility.setNodeVisibility(bikeParts[index], 1);
    }
  }

  showPart(sku, platform) {
    console.log("[ModelManager] adding part", sku);

    // TODO: remove this hack
    // hack for handguard
    if (sku == 219400998) {
      const res = this._bikeGeometryManager.addPart("handguardfiller");
      this.doActions(res);
    }

    const result = this._bikeGeometryManager.addPart(sku, platform);

    console.log("[ModelManager] changes ", result);

    this.doActions(result);
  }

  hidePart(sku, platform) {
    console.log("[ModelManager] removing part part", sku);

    // TODO: remove this hack
    // hack for handguard
    if (sku == 219400998) {
      const res = this._bikeGeometryManager.removePart("handguardfiller");
      this.doActions(res);
    }

    const result = this._bikeGeometryManager.removePart(sku, platform);

    console.log("[ModelManager] changes ", result);

    this.doActions(result);
  }

  doActions(action) {
    if (action.hideNodes) {
      for (const i in action.hideNodes) {
        this._sketchfabAPIUtility.setNodeVisibility(action.hideNodes[i], 0);
      }
    }
    if (action.showNodes) {
      for (const i in action.showNodes) {
        this._sketchfabAPIUtility.setNodeVisibility(action.showNodes[i], 1);
      }
    }
  }

  hideAllParts() {
    this.printModel();
    this._sketchfabAPIUtility.setNodeVisibility("MY22_rally", 0);
    this._sketchfabAPIUtility.setNodeVisibility("MY22_sport_rally", 0);
    this._sketchfabAPIUtility.setNodeVisibility("MY22_sport", 0);
    this._sketchfabAPIUtility.setNodeVisibility("MY22_600_900_sport", 0);
    this._sketchfabAPIUtility.setNodeVisibility("MY22_base_600_900", 0);
    this._sketchfabAPIUtility.setNodeVisibility("MY22_base_600_900", 0);
    for (const index in partInfo.accessories) {
      this._sketchfabAPIUtility.setNodeVisibility(
        partInfo.accessories[index],
        0
      );
    }
    for (const index in partInfo.common) {
      this._sketchfabAPIUtility.setNodeVisibility(partInfo.common[index], 0);
    }
  }

  setCameraPosition(pos) {
    // Change Camera
    const coords = pos.split(",");
    const position = {
      x: coords[0],
      y: coords[1],
      z: coords[2],
    };
    const target = {
      x: coords[3],
      y: coords[4],
      z: coords[5],
    };

    this._sketchfabAPIUtility.setCamera(position, target, 1.5);
  }

  resetCamera() {
    if (this._sketchfabAPIUtility) {
      this.setCameraPosition("-238.32, 274.36, -4936.1,-11.4, 0, -4998.9");
    }
  }

  printModel() {
    console.dir(this._sketchfabAPIUtility.nodeHash);
  }
}



// WEBPACK FOOTER //
// ./src/managers/Model/index.js